module.exports = __webpack_public_path__ + "img/RENTRER_SEUL_ACTIVE.6f172839.svg";